import { FunctionComponent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useActualUser from "../../../utilities/useActualUser";
import Loader from "../../../ui/components/Loader/Loader";

interface ProtectedRouteProps {
  children: any;
}

const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = ({
  children,
}) => {
  const { isLoggedIn, isLoading } = useActualUser();
  const location = useLocation();

  if (isLoading) {
    return <Loader height="100vh" width="100%" />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;